import { render, staticRenderFns } from "./com-pagetabs.vue?vue&type=template&id=617500fc&"
import script from "./com-pagetabs.vue?vue&type=script&lang=js&"
export * from "./com-pagetabs.vue?vue&type=script&lang=js&"
import style0 from "./com-pagetabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports